module.exports = __webpack_public_path__ + "static/media/img_sheeren.7750efef.png";